module.exports = __webpack_public_path__ + "img/coverTeasingMobile.cd90f521.png";